import { useSnackbar } from "@aidergroup/ui-v2";
import { FirebaseError } from "firebase/app";
import { Logger } from "@/types/utils";
import * as Sentry from "@sentry/react";
import { ignoreFirebaseError } from "./validations";
import { i18n } from "./i18n";

const show = useSnackbar.getState().show;

export const log: Logger = {
    success: (message: string) => {
        show(message, "success");
    },
    info: (message: string) => {
        show(message, "info");
    },
    warn: (message: string) => {
        show(message, "warning");
    },
    error: (error: unknown, cause: string) => {
        let message = i18n.t("error.unknownError", { scope: "messages" });

        if (error instanceof FirebaseError) {
            message = error.message;
        } else if (error instanceof Error) {
            if (error.name === "AbortError") message = "Request has been canceled our timed out";
            else message = error.message;
        }

        message = message.replace(/( *)?\$sentry-ignore/, "");

        show(message, "error");
        if (error instanceof FirebaseError && ignoreFirebaseError(error)) return;

        Sentry.captureException(error, { extra: { cause }, level: "error" });
    },
};
